(function () {
  var NEEDS_OPTIONS_KEY = 'sculptWishlistNeedsOptions';
  var VARIANT_IMAGE_KEY = 'sculptWishlistVariantImages';
  var VARIANT_META_KEY = 'sculptWishlistVariantMeta';
  var pendingWishlistSource = null;

  function readJsonStore(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeJsonStore(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function readNeedsOptions() {
    return readJsonStore(NEEDS_OPTIONS_KEY);
  }

  function setNeedsOptions(productId, needs) {
    if (!productId) return;
    var store = readNeedsOptions();
    store[String(productId)] = !!needs;
    writeJsonStore(NEEDS_OPTIONS_KEY, store);
  }

  function setStoredVariantMeta(productId, variantId, meta) {
    if (!productId || !variantId || !meta) return;
    var store = readJsonStore(VARIANT_META_KEY);
    var key = String(productId) + ':' + String(variantId);
    var next = Object.assign({}, store[key] || {});
    Object.keys(meta).forEach(function (prop) {
      if (meta[prop] !== '' && meta[prop] != null) next[prop] = meta[prop];
    });
    store[key] = next;
    writeJsonStore(VARIANT_META_KEY, store);
  }

  function getStoredVariantMeta(productId, variantId) {
    var store = readJsonStore(VARIANT_META_KEY);
    return store[String(productId) + ':' + String(variantId)] || null;
  }

  function setStoredVariantImage(productId, variantId, url) {
    if (!productId || !variantId || !url) return;
    var store = readJsonStore(VARIANT_IMAGE_KEY);
    store[String(productId) + ':' + String(variantId)] = url;
    writeJsonStore(VARIANT_IMAGE_KEY, store);
    setStoredVariantMeta(productId, variantId, { image: url });
  }

  function getStoredVariantImage(productId, variantId) {
    var meta = getStoredVariantMeta(productId, variantId);
    if (meta && meta.image) return meta.image;
    var store = readJsonStore(VARIANT_IMAGE_KEY);
    return store[String(productId) + ':' + String(variantId)] || '';
  }

  function productNeedsOptions(productId) {
    var store = readNeedsOptions();
    if (Object.prototype.hasOwnProperty.call(store, String(productId))) {
      return !!store[String(productId)];
    }
    return null;
  }

  function pdpHasCompleteVariant() {
    var select = document.querySelector('[data-variant-id-select]');
    if (select && String(select.value || '').trim()) return true;

    var groups = document.querySelectorAll('[data-product-section] [data-option-position], .product-options [data-option-position]');
    if (!groups.length) return false;

    for (var i = 0; i < groups.length; i += 1) {
      if (!groups[i].querySelector('.is-selected[data-option-value]')) return false;
    }
    return true;
  }

  function setButtonVariant(el, variantId) {
    if (!el || !variantId) return;
    el.setAttribute('data-variant', String(variantId));
    if (window.jQuery) {
      // Smart Wishlist baca jQuery .data('variant') yang di-cache — harus di-sync
      window.jQuery(el).data('variant', String(variantId));
    }
    el.querySelectorAll('[data-variant]').forEach(function (child) {
      child.setAttribute('data-variant', String(variantId));
      if (window.jQuery) window.jQuery(child).data('variant', String(variantId));
    });
  }

  function syncWishlistVariantFromPdp() {
    var select = document.querySelector('[data-variant-id-select]');
    var button = document.getElementById('smartwishlist') || document.querySelector('.product-gallery__wishlist');
    if (!select || !button || !String(select.value || '').trim()) return;
    setButtonVariant(button, select.value);
  }

  function syncWishlistVariantFromCard(source) {
    if (!source) return;
    var productCard = source.closest('.product-card');
    if (!productCard) return;

    var productId = source.getAttribute('data-product');
    var selected = productCard.querySelector('[data-product-swatch].is-selected');
    var variantId =
      (selected && selected.getAttribute('data-variant-id')) || source.getAttribute('data-variant') || '';
    var imageUrl = '';

    if (selected && selected.getAttribute('data-image-url')) {
      imageUrl = selected.getAttribute('data-image-url');
    } else {
      var primaryImage = productCard.querySelector('.product-card__image--primary');
      if (primaryImage) imageUrl = primaryImage.currentSrc || primaryImage.src || '';
    }

    if (variantId) setButtonVariant(source, variantId);

    if (productId && variantId && imageUrl) {
      setStoredVariantImage(productId, variantId, imageUrl);
    }

    var colorName = selected && selected.getAttribute('data-color-name');
    var colorHex = selected && selected.getAttribute('data-color-hex');
    if (productId && variantId && (colorName || colorHex)) {
      setStoredVariantMeta(productId, variantId, {
        color: colorName || '',
        hex: colorHex || '',
      });
    }
  }

  function rememberWishlistSource(event) {
    var card = event.target.closest && event.target.closest('.smartwishlist[data-sculpt-source="card"], .smartwishlist.product-card__wishlist');
    var pdp = event.target.closest && event.target.closest('#smartwishlist, .product-gallery__wishlist, .smartwishlist[data-sculpt-source="product"]');
    var source = card || pdp;
    if (!source) return;

    var productId = source.getAttribute('data-product');
    // Selalu Add to cart di wishlist — tidak pakai Select options
    var needsOptions = false;

    if (card) {
      syncWishlistVariantFromCard(card);
    } else if (pdp) {
      if (pdpHasCompleteVariant()) {
        syncWishlistVariantFromPdp();
        var select = document.querySelector('[data-variant-id-select]');
        var mainImg = document.querySelector('[data-product-main-image]');
        if (select && select.value && mainImg) {
          setStoredVariantImage(productId, select.value, mainImg.currentSrc || mainImg.src);
        }
      }
    }

    pendingWishlistSource = { productId: productId, needsOptions: needsOptions };
    setNeedsOptions(productId, needsOptions);
  }

  document.addEventListener('pointerdown', rememberWishlistSource, true);
  document.addEventListener('mousedown', rememberWishlistSource, true);
  document.addEventListener('click', rememberWishlistSource, true);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-variant-id-select]')) {
      syncWishlistVariantFromPdp();
    }
  });

  function disableWishlistHoverTooltips() {
    document.querySelectorAll('.smartwishlist, #bookmarkit, #smartwishlist, #smartwishlist_desktop_link').forEach(function (el) {
      el.removeAttribute('title');

      if (window.jQuery) {
        var $el = window.jQuery(el);

        if (window.jQuery.fn.tooltipster && $el.data('tooltipster')) {
          try {
            $el.tooltipster('destroy');
          } catch (error) {}
        }

        $el.off('mouseenter mouseleave');
      }
    });

    document.querySelectorAll('.tooltipster-sidetip, .tooltipster-base').forEach(function (el) {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
    });
  }

  function watchWishlistTooltips() {
    disableWishlistHoverTooltips();

    if (!window.__sculptWishlistTooltipObserver && window.MutationObserver) {
      var tooltipTimer;

      window.__sculptWishlistTooltipObserver = new MutationObserver(function () {
        window.clearTimeout(tooltipTimer);
        tooltipTimer = window.setTimeout(disableWishlistHoverTooltips, 50);
      });

      window.__sculptWishlistTooltipObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['title', 'class'],
      });
    }
  }

  function applyPendingWishlistSource() {
    if (pendingWishlistSource && pendingWishlistSource.productId) {
      setNeedsOptions(pendingWishlistSource.productId, pendingWishlistSource.needsOptions);
    }
  }

  function markWishlistButtonFilled(el) {
    if (!el) return;
    el.classList.remove('unbookmarked');
    el.classList.add('bookmarked');
    el.setAttribute('aria-label', el.getAttribute('aria-label') || window.SculptStrings?.wishlistRemove || 'Remove from wishlist');

    var config = window.smartwishlist_local_config || {};
    var outline = config.wishlist_icon_name || 'heart-o';
    var filled = config.wishlist_icon_hover_name || 'heart';
    var extraOut = config.extra_icon_class_name || '';
    var extraFill = config.extra_icon_hover_class_name || '';

    el.querySelectorAll('span, .fa, #wishlist_icon').forEach(function (icon) {
      if (extraOut && extraFill) {
        icon.classList.remove(extraOut);
        icon.classList.add(extraFill);
      }
      icon.classList.remove('fa-' + outline);
      icon.classList.add('fa-' + filled);
    });

    var bookmarkit = el.id === 'bookmarkit' ? el : el.querySelector('#bookmarkit');
    if (bookmarkit && bookmarkit !== el) {
      bookmarkit.classList.remove('unbookmarked');
      bookmarkit.classList.add('bookmarked');
      bookmarkit.setAttribute('status', 'bookmarked');
    }
  }

  function onWishlistItemAdded() {
    applyPendingWishlistSource();
    if (!pendingWishlistSource || !pendingWishlistSource.productId) return;

    document
      .querySelectorAll(
        '.smartwishlist[data-product="' +
          pendingWishlistSource.productId +
          '"], #smartwishlist[data-product="' +
          pendingWishlistSource.productId +
          '"]'
      )
      .forEach(markWishlistButtonFilled);
  }

  function onWishlistItemRemoved() {
    if (document.querySelector('.wishlistpage')) {
      reloadWishlistPageAfterRemove();
    }
  }

  window.SWCallbackExpressWishlistCollectionItemAdded = onWishlistItemAdded;
  window.SWCallbackExpressWishlistProductItemAdded = onWishlistItemAdded;
  window.SWCallbackCustomerWishlistCollectionItemAdded = onWishlistItemAdded;
  window.SWCallbackCustomerWishlistProductItemAdded = onWishlistItemAdded;

  window.SWCallbackExpressWishlistCollectionItemRemoved = onWishlistItemRemoved;
  window.SWCallbackExpressWishlistProductItemRemoved = onWishlistItemRemoved;
  window.SWCallbackCustomerWishlistCollectionItemRemoved = onWishlistItemRemoved;
  window.SWCallbackCustomerWishlistProductItemRemoved = onWishlistItemRemoved;

  window.SWCallbackWishlistButtonLoaded = function () {
    watchWishlistTooltips();
  };

  function addWishlistTitleClass() {
    document.querySelectorAll('.wishlistpage h1.titletext').forEach(function (title) {
      title.classList.add('h2');
    });
  }

  function formatWishlistPrice(text) {
    if (!text) return '';
    return String(text)
      .replace(/\s*IDR\s*/gi, ' ')
      .replace(/([.,]00)(?=\D|$)/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hideWishlistModals() {
    var $ = window.jQuery;
    if ($) {
      try {
        $('#remove_modal, #remove_all_modal, #message_modal').modal('hide');
      } catch (error) {}
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open').css('padding-right', '');
    }

    document.querySelectorAll('#remove_modal, #remove_all_modal, #message_modal, .modal-backdrop').forEach(function (el) {
      el.style.display = 'none';
      el.classList.remove('in', 'show');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function showInlineRemovedNotice() {
    /* Notifikasi remove di wishlist page dinonaktifkan */
  }

  var REMOVED_NOTICE_KEY = 'sculptWishlistRemoved';
  var wishlistReloading = false;

  function reloadWishlistPageAfterRemove() {
    if (wishlistReloading || !document.querySelector('.wishlistpage')) return;
    wishlistReloading = true;
    try {
      sessionStorage.setItem(REMOVED_NOTICE_KEY, '1');
    } catch (error) {}
    hideWishlistModals();
    window.setTimeout(function () {
      window.location.reload();
    }, 180);
  }

  function restoreRemovedNotice() {
    try {
      if (sessionStorage.getItem(REMOVED_NOTICE_KEY) !== '1') return;
      sessionStorage.removeItem(REMOVED_NOTICE_KEY);
    } catch (error) {
      return;
    }
    showInlineRemovedNotice();
  }

  function isOutOfStock(button) {
    if (!button) return false;
    if (button.classList.contains('disabled') || button.classList.contains('wp_disabled')) return true;
    return /out of stock/i.test((button.textContent || '').trim());
  }

  function isChosenVariantValue(value) {
    if (value === true || value === 1) return true;
    var normalized = String(value == null ? '' : value).toLowerCase().trim();
    return normalized === '1' || normalized === 'true';
  }

  function wishlistItemData(productId, variantId) {
    var list = window.wishlist_item_data || window.product_data || [];
    if (!list || !list.length) return null;
    for (var i = 0; i < list.length; i += 1) {
      var item = list[i];
      if (String(item.id) === String(productId) && String(item.variant_id) === String(variantId)) {
        return item;
      }
    }
    return null;
  }

  function needsVariantSelection(button, productId, variantId) {
    // Jangan tampilkan Select options — selalu Add to cart
    return false;
  }

  function uncroppedImageUrl(src) {
    if (!src) return src;
    return src.replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048)(?=\.(jpg|jpeg|png|webp|gif))/i,
      ''
    );
  }

  function extractColorHex(value) {
    if (!value) return '';
    // Support "#000000_Black", "000000_Black", "#000000"
    var match = String(value).trim().match(/#?([0-9A-Fa-f]{6})(?=[^0-9A-Fa-f]|$)/);
    return match ? '#' + match[1].toUpperCase() : '';
  }

  function hexFromColorName(name) {
    if (!name) return '';
    var key = String(name).toLowerCase().replace(/[^a-z0-9]+/g, '');
    var map = {
      black: '#000000',
      white: '#FFFFFF',
      nude: '#E8D5C4',
      beige: '#E8D5C4',
      ivory: '#FFFFF0',
      cream: '#FFFDD0',
      brown: '#8B4513',
      taupe: '#B38B6D',
      grey: '#808080',
      gray: '#808080',
      red: '#C41E3A',
      pink: '#FFC0CB',
      blue: '#4A6FA5',
      navy: '#000080',
      green: '#228B22',
      olive: '#808000',
    };
    return map[key] || '';
  }

  function resolveColorHex(rawValue, label) {
    return extractColorHex(rawValue) || hexFromColorName(label) || hexFromColorName(cleanColorLabel(rawValue));
  }

  function paintWishlistColorSwatch(colorEl, hex, label) {
    if (!colorEl || !hex) return;
    colorEl.hidden = false;
    colorEl.removeAttribute('hidden');
    colorEl.setAttribute('data-hex', hex);
    colorEl.setAttribute('aria-label', label || hex);
    colorEl.style.backgroundColor = hex;

    var tooltip = colorEl.querySelector('.color-swatch__tooltip');
    if (!tooltip) {
      tooltip = document.createElement('span');
      tooltip.className = 'color-swatch__tooltip';
      colorEl.appendChild(tooltip);
    }
    tooltip.textContent = label || hex;
    if (label) colorEl.title = '';
  }

  function variantColorHex(variant, product) {
    if (!variant) return '';
    var optionNames = (product && product.options) || [];
    for (var i = 0; i < optionNames.length; i += 1) {
      if (/color|colour|warna|shade/i.test(String(optionNames[i] || ''))) {
        var raw = (variant.options && variant.options[i]) || variant['option' + (i + 1)];
        return resolveColorHex(raw, cleanColorLabel(raw));
      }
    }
    return (
      resolveColorHex(variant.option1, cleanColorLabel(variant.option1)) ||
      resolveColorHex(variant.options && variant.options[0], cleanColorLabel(variant.options && variant.options[0])) ||
      resolveColorHex(variant.title, cleanColorLabel(String(variant.title || '').split(' / ')[0]))
    );
  }

  function variantColorLabel(variant, product) {
    if (!variant) return '';

    var optionNames = (product && product.options) || [];
    for (var i = 0; i < optionNames.length; i += 1) {
      if (/color|colour|warna|shade/i.test(String(optionNames[i] || ''))) {
        return cleanColorLabel((variant.options && variant.options[i]) || variant['option' + (i + 1)]);
      }
    }

    if (variant.title && variant.title !== 'Default Title') {
      return cleanColorLabel(String(variant.title).split(' / ')[0]);
    }

    return cleanColorLabel(variant.option1 || (variant.options && variant.options[0]));
  }

  function cleanColorLabel(value) {
    if (!value) return '';
    var text = String(value).trim();
    if (text.indexOf('_') !== -1) {
      var parts = text.split('_');
      var maybeHex = parts[0].replace('#', '');
      if (/^[0-9A-Fa-f]{6}$/.test(maybeHex) && parts.length > 1) {
        return parts.slice(1).join(' ').trim();
      }
    }
    return text;
  }

  function colorHintFromProductNode(product) {
    if (!product) return { hex: '', label: '' };
    var nodes = product.querySelectorAll(
      '.variant, .variants, .product-variant, .option, .options, .swatch, [class*="variant"], [class*="color"], [class*="warna"]'
    );
    for (var i = 0; i < nodes.length; i += 1) {
      var text = (nodes[i].textContent || '').trim();
      if (!text || text.length > 80) continue;
      var label = cleanColorLabel(text.split('/')[0]);
      var hex = resolveColorHex(text, label);
      if (hex) return { hex: hex, label: label };
    }
    return { hex: '', label: '' };
  }

  function productHandleFromSources(titleLink, productHref, itemData) {
    var href =
      (titleLink && titleLink.getAttribute('href')) ||
      productHref ||
      (itemData && itemData.handle ? '/products/' + itemData.handle : '') ||
      '';
    if (!href) return '';
    return href.replace(/^\/products\//, '').split('?')[0].split('/')[0];
  }

  function applyWishlistColor(colorEl, productId, variantId, titleLink, productHref, productNode) {
    if (!colorEl || !variantId) return;

    var storedMeta = getStoredVariantMeta(productId, variantId) || {};
    var itemData = wishlistItemData(productId, variantId);
    var hint = colorHintFromProductNode(productNode);
    var resolvedHex =
      storedMeta.hex ||
      hint.hex ||
      resolveColorHex(storedMeta.color, storedMeta.color) ||
      (itemData &&
        resolveColorHex(
          itemData.variant_title || itemData.variants || itemData.title || '',
          cleanColorLabel(String(itemData.variant_title || '').split('/')[0])
        ));
    var resolvedLabel = storedMeta.color || hint.label || '';

    if (resolvedHex) {
      paintWishlistColorSwatch(colorEl, resolvedHex, resolvedLabel);
      setStoredVariantMeta(productId, variantId, { hex: resolvedHex, color: resolvedLabel });
      return;
    }

    var handle = productHandleFromSources(titleLink, productHref, itemData);
    if (!handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        var variant = (product.variants || []).find(function (item) {
          return String(item.id) === String(variantId);
        });
        var color = variantColorLabel(variant, product);
        var hex = variantColorHex(variant, product) || resolveColorHex(color, color);
        if (color || hex) {
          setStoredVariantMeta(productId, variantId, { color: color || '', hex: hex || '' });
        }
        if (hex) paintWishlistColorSwatch(colorEl, hex, color || '');
      })
      .catch(function () {});
  }

  function applyVariantImage(imgEl, productId, variantId, titleLink, productHref) {
    if (!imgEl || !variantId) return;

    var stored = getStoredVariantImage(productId, variantId);
    if (stored) {
      imgEl.src = uncroppedImageUrl(stored);
      return;
    }

    var itemData = wishlistItemData(productId, variantId);
    var handle = productHandleFromSources(titleLink, productHref, itemData);
    if (!handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        var variant = (product.variants || []).find(function (item) {
          return String(item.id) === String(variantId);
        });
        var src = variant && variant.featured_image && (variant.featured_image.src || variant.featured_image);
        if (!src && product.images) {
          var match = product.images.find(function (image) {
            return (image.variant_ids || []).map(String).indexOf(String(variantId)) !== -1;
          });
          if (match) src = match.src;
        }
        if (!src) return;
        imgEl.src = uncroppedImageUrl(src);
        setStoredVariantImage(productId, variantId, src);
      })
      .catch(function () {});
  }

  function productUrlFromButton(button, titleLink) {
    var url = button && button.getAttribute('data-url');
    if (url) return url;
    if (titleLink && titleLink.getAttribute('href')) {
      return titleLink.getAttribute('href').split('?')[0];
    }
    return '/';
  }

  function styleActionButton(addBtn, titleLink, outOfStock, needsOptions) {
    if (!addBtn) return;

    if (outOfStock) {
      addBtn.className = 'sculpt-wishlist-add addbutton addsingleproduct is-disabled disabled';
      addBtn.textContent = window.SculptStrings?.productsOutOfStock || 'Out of stock';
      addBtn.setAttribute('href', '#');
      return;
    }

    addBtn.className = 'sculpt-wishlist-add addbutton addsingleproduct';
    addBtn.textContent = window.SculptStrings?.productsAddToCart || 'Add to cart';
    addBtn.setAttribute('href', '#');
    addBtn.setAttribute('aria-label', window.SculptStrings?.productsAddToCart || 'Add to cart');
  }

  function buildWishlistGrid() {
    var bookmarks = document.getElementById('bookmarks');
    if (!bookmarks || !document.querySelector('.wishlistpage')) return;

    var products = Array.prototype.slice.call(bookmarks.querySelectorAll('.product'));
    var emptyNotice = bookmarks.querySelector('.empty-wishlist');
    var hasGrid = bookmarks.querySelector('.sculpt-wishlist-grid');
    if (hasGrid && !products.length && !emptyNotice) return;
    if (!products.length && !emptyNotice) return;

    var grid = document.createElement('div');
    grid.className = 'sculpt-wishlist-grid';

    if (!products.length || emptyNotice) {
      var empty = document.createElement('p');
      empty.className = 'sculpt-wishlist-empty';
      empty.textContent = window.SculptStrings?.wishlistEmpty || 'No products added to the wishlist';
      grid.appendChild(empty);
    } else {
      products.forEach(function (product) {
        var removeBtn = product.querySelector('.singleremovebutton');
        var addBtn = product.querySelector('.addsingleproduct');
        var imageLink = product.querySelector('.image a');
        var titleLink = product.querySelector('.product_title a');
        var price = product.querySelector('.price');
        var productId =
          product.getAttribute('data-productid') ||
          (removeBtn && removeBtn.getAttribute('data-productid')) ||
          (addBtn && addBtn.getAttribute('data-productid')) ||
          '';
        var variantId =
          product.getAttribute('data-variantid') ||
          (removeBtn && removeBtn.getAttribute('data-variantid')) ||
          (addBtn && addBtn.getAttribute('data-variantid')) ||
          '';
        var outOfStock = isOutOfStock(addBtn);
        var needsOptions = needsVariantSelection(addBtn, productId, variantId);
        var priceText = price ? formatWishlistPrice(price.textContent) : '';
        var productHref = productUrlFromButton(addBtn, titleLink);

        var card = document.createElement('article');
        card.className = 'sculpt-wishlist-card product-card';
        if (productId && variantId) card.id = 'product_' + productId + '_' + variantId;

        var mediaWrap = document.createElement('div');
        mediaWrap.className = 'sculpt-wishlist-card__media-wrap product-card__media-wrap';

        var media = document.createElement('a');
        media.className = 'sculpt-wishlist-card__media product-card__media';
        media.href = needsOptions ? productHref : (imageLink && imageLink.getAttribute('href')) || productHref;

        var thumbImg = imageLink && imageLink.querySelector('img');
        if (thumbImg) {
          var img = document.createElement('img');
          img.className = 'sculpt-wishlist-card__image product-card__image product-card__image--primary';
          img.alt = (titleLink && titleLink.textContent) || '';
          img.loading = 'lazy';
          img.src = uncroppedImageUrl(thumbImg.getAttribute('src') || thumbImg.src);
          media.appendChild(img);
        }

        mediaWrap.appendChild(media);

        if (removeBtn) {
          removeBtn.className = 'sculpt-wishlist-remove singleremovebutton removebutton';
          removeBtn.setAttribute('aria-label', window.SculptStrings?.wishlistRemove || 'Remove from wishlist');
          removeBtn.innerHTML =
            '<span class="sculpt-wishlist-remove__x" aria-hidden="true">×</span>';
          mediaWrap.appendChild(removeBtn);
        }

        if (outOfStock) {
          var badge = document.createElement('span');
          badge.className = 'sculpt-wishlist-card__badge';
          badge.textContent = window.SculptStrings?.productsSoldOut || 'Sold out';
          mediaWrap.appendChild(badge);
        }

        var content = document.createElement('div');
        content.className = 'sculpt-wishlist-card__content product-card__content';

        if (titleLink) {
          var title = document.createElement('a');
          title.className = 'sculpt-wishlist-card__title product-card__title';
          title.href = titleLink.getAttribute('href') || productHref;
          title.textContent = (titleLink.textContent || '').trim();
          content.appendChild(title);
        }

        var priceEl = document.createElement('p');
        priceEl.className = 'sculpt-wishlist-card__price product-card__price';
        priceEl.textContent = priceText;
        content.appendChild(priceEl);

        var colorEl = document.createElement('button');
        colorEl.type = 'button';
        colorEl.className = 'sculpt-wishlist-card__color color-swatch';
        colorEl.hidden = true;
        colorEl.setAttribute('aria-label', window.SculptStrings?.productsColor || 'Color');
        content.appendChild(colorEl);

        var stockEl = document.createElement('p');
        stockEl.className = 'sculpt-wishlist-card__stock';
        stockEl.textContent = outOfStock
          ? window.SculptStrings?.productsOutOfStock || 'Out of stock'
          : window.SculptStrings?.productsInStock || 'In stock';
        content.appendChild(stockEl);

        if (addBtn) {
          styleActionButton(addBtn, titleLink, outOfStock, needsOptions);
          content.appendChild(addBtn);
        }

        card.appendChild(mediaWrap);
        card.appendChild(content);
        grid.appendChild(card);

        applyWishlistColor(colorEl, productId, variantId, titleLink, productHref, product);
        if (thumbImg) {
          applyVariantImage(media.querySelector('img'), productId, variantId, titleLink, productHref);
        }
      });
    }

    bookmarks.innerHTML = '';
    bookmarks.appendChild(grid);
  }

  var originalWishlistLoaded = window.WishlistLoadedCallback;
  window.WishlistLoadedCallback = function () {
    if (typeof originalWishlistLoaded === 'function') originalWishlistLoaded();
    window.setTimeout(buildWishlistGrid, 0);
    addWishlistTitleClass();
    watchWishlistTooltips();
  };

  function watchWishlistPage() {
    var bookmarks = document.getElementById('bookmarks');
    if (!bookmarks || bookmarks.dataset.sculptObserved) return;
    bookmarks.dataset.sculptObserved = '1';
    if (!window.MutationObserver) return;

    var timer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(buildWishlistGrid, 30);
    });
    observer.observe(bookmarks, { childList: true, subtree: true });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!document.querySelector('.wishlistpage')) return;

      var btn = event.target.closest && event.target.closest('.singleremovebutton, .sculpt-wishlist-remove');
      if (!btn) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var productId = btn.getAttribute('data-productid');
      var variantId = btn.getAttribute('data-variantid');
      var modalBtn = document.getElementById('modal_remove_button');

      if (modalBtn) {
        modalBtn.setAttribute('data-product_id', productId);
        modalBtn.setAttribute('data-variant_id', variantId);
        if (window.jQuery) window.jQuery(modalBtn).trigger('click');
        else modalBtn.click();
      } else if (typeof window.RemoveFromSmartWishlist === 'function') {
        window.RemoveFromSmartWishlist(productId, variantId);
        var card = document.getElementById('product_' + productId + '_' + variantId);
        if (card) card.remove();
      }

      reloadWishlistPageAfterRemove();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      addWishlistTitleClass();
      restoreRemovedNotice();
    });
  } else {
    addWishlistTitleClass();
    restoreRemovedNotice();
  }

  window.addEventListener('load', function () {
    addWishlistTitleClass();
    restoreRemovedNotice();
    watchWishlistTooltips();
    watchWishlistPage();
    window.setTimeout(watchWishlistTooltips, 500);
    window.setTimeout(watchWishlistTooltips, 1500);
    window.setTimeout(buildWishlistGrid, 400);
    window.setTimeout(buildWishlistGrid, 1200);
    window.setTimeout(buildWishlistGrid, 2500);
  });
})();
